var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-collapse",
        { attrs: { accordion: "" } },
        [
          _vm.main.vaildProp("titleList")
            ? [
                _c(
                  "el-collapse-item",
                  { attrs: { title: "标题设置" } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "标题" } },
                      [
                        _c("el-switch", {
                          model: {
                            value: _vm.main.activeOption.title.show,
                            callback: function ($$v) {
                              _vm.$set(_vm.main.activeOption.title, "show", $$v)
                            },
                            expression: "main.activeOption.title.show",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "标题" } },
                      [
                        _c("el-input", {
                          model: {
                            value: _vm.main.activeOption.title.text,
                            callback: function ($$v) {
                              _vm.$set(_vm.main.activeOption.title, "text", $$v)
                            },
                            expression: "main.activeOption.title.text",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "字体颜色" } },
                      [
                        _c("el-color-picker", {
                          model: {
                            value: _vm.main.activeOption.title.textStyle.color,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.main.activeOption.title.textStyle,
                                "color",
                                $$v
                              )
                            },
                            expression:
                              "main.activeOption.title.textStyle.color",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "字体大小" } },
                      [
                        _c("el-input-number", {
                          model: {
                            value:
                              _vm.main.activeOption.title.textStyle.fontSize,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.main.activeOption.title.textStyle,
                                "fontSize",
                                $$v
                              )
                            },
                            expression:
                              "main.activeOption.title.textStyle.fontSize",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "字体位置" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { placeholder: "请选择" },
                            model: {
                              value: _vm.main.activeOption.title.left,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.main.activeOption.title,
                                  "left",
                                  $$v
                                )
                              },
                              expression: "main.activeOption.title.left",
                            },
                          },
                          _vm._l(_vm.dicOption.textAlign, function (item) {
                            return _c("el-option", {
                              key: item.value,
                              attrs: { label: item.label, value: item.value },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "副标题" } },
                      [
                        _c("el-input", {
                          model: {
                            value: _vm.main.activeOption.title.subtext,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.main.activeOption.title,
                                "subtext",
                                $$v
                              )
                            },
                            expression: "main.activeOption.title.subtext",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "字体颜色" } },
                      [
                        _c("el-color-picker", {
                          model: {
                            value:
                              _vm.main.activeOption.title.subtextStyle.color,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.main.activeOption.title.subtextStyle,
                                "color",
                                $$v
                              )
                            },
                            expression:
                              "main.activeOption.title.subtextStyle.color",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "字体大小" } },
                      [
                        _c("el-input-number", {
                          model: {
                            value:
                              _vm.main.activeOption.title.subtextStyle.fontSize,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.main.activeOption.title.subtextStyle,
                                "fontSize",
                                $$v
                              )
                            },
                            expression:
                              "main.activeOption.title.subtextStyle.fontSize",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.main.vaildProp("labelList")
            ? [
                _c(
                  "el-collapse-item",
                  { attrs: { title: "数值设置" } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "显示" } },
                      [
                        _c("el-switch", {
                          model: {
                            value:
                              _vm.main.activeOption.extend.series.label.normal
                                .show,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.main.activeOption.extend.series.label
                                  .normal,
                                "show",
                                $$v
                              )
                            },
                            expression:
                              "main.activeOption.extend.series.label.normal.show",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "位置" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { placeholder: "请选择" },
                            model: {
                              value:
                                _vm.main.activeOption.extend.series.label.normal
                                  .position,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.main.activeOption.extend.series.label
                                    .normal,
                                  "position",
                                  $$v
                                )
                              },
                              expression:
                                "main.activeOption.extend.series.label.normal.position",
                            },
                          },
                          _vm._l(_vm.dicOption.labelPosition, function (item) {
                            return _c("el-option", {
                              key: item,
                              attrs: { label: item, value: item },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "字体大小" } },
                      [
                        _c("el-input-number", {
                          model: {
                            value:
                              _vm.main.activeOption.extend.series.label.normal
                                .fontSize,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.main.activeOption.extend.series.label
                                  .normal,
                                "fontSize",
                                $$v
                              )
                            },
                            expression:
                              "main.activeOption.extend.series.label.normal.fontSize",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "字体颜色" } },
                      [
                        _c("el-color-picker", {
                          model: {
                            value:
                              _vm.main.activeOption.extend.series.label.normal
                                .color,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.main.activeOption.extend.series.label
                                  .normal,
                                "color",
                                $$v
                              )
                            },
                            expression:
                              "main.activeOption.extend.series.label.normal.color",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "字体粗细" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { placeholder: "请选择" },
                            model: {
                              value:
                                _vm.main.activeOption.extend.series.label.normal
                                  .fontWeight,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.main.activeOption.extend.series.label
                                    .normal,
                                  "fontWeight",
                                  $$v
                                )
                              },
                              expression:
                                "main.activeOption.extend.series.label.normal.fontWeight",
                            },
                          },
                          _vm._l(_vm.dicOption.fontWeight, function (item) {
                            return _c("el-option", {
                              key: item.value,
                              attrs: { label: item.label, value: item.value },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.main.vaildProp("tipList")
            ? [
                _c(
                  "el-collapse-item",
                  { attrs: { title: "提示语设置" } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "字体大小" } },
                      [
                        _c("el-input-number", {
                          model: {
                            value:
                              _vm.main.activeOption.tooltip.textStyle.fontSize,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.main.activeOption.tooltip.textStyle,
                                "fontSize",
                                $$v
                              )
                            },
                            expression:
                              "main.activeOption.tooltip.textStyle.fontSize",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "字体颜色" } },
                      [
                        _c("el-color-picker", {
                          model: {
                            value:
                              _vm.main.activeOption.tooltip.textStyle.color,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.main.activeOption.tooltip.textStyle,
                                "color",
                                $$v
                              )
                            },
                            expression:
                              "main.activeOption.tooltip.textStyle.color",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.main.vaildProp("postionList")
            ? [
                _c(
                  "el-collapse-item",
                  { attrs: { title: "坐标轴边距设置" } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "左边距(像素)" } },
                      [
                        _c("el-slider", {
                          attrs: { max: 400 },
                          model: {
                            value: _vm.main.activeOption.grid.left,
                            callback: function ($$v) {
                              _vm.$set(_vm.main.activeOption.grid, "left", $$v)
                            },
                            expression: "main.activeOption.grid.left",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "顶边距(像素)" } },
                      [
                        _c("el-slider", {
                          attrs: { max: 400 },
                          model: {
                            value: _vm.main.activeOption.grid.top,
                            callback: function ($$v) {
                              _vm.$set(_vm.main.activeOption.grid, "top", $$v)
                            },
                            expression: "main.activeOption.grid.top",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "右边距(像素)" } },
                      [
                        _c("el-slider", {
                          attrs: { max: 400 },
                          model: {
                            value: _vm.main.activeOption.grid.right,
                            callback: function ($$v) {
                              _vm.$set(_vm.main.activeOption.grid, "right", $$v)
                            },
                            expression: "main.activeOption.grid.right",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "底边距(像素)" } },
                      [
                        _c("el-slider", {
                          attrs: { max: 400 },
                          model: {
                            value: _vm.main.activeOption.grid.bottom,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.main.activeOption.grid,
                                "bottom",
                                $$v
                              )
                            },
                            expression: "main.activeOption.grid.bottom",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.main.vaildProp("barList")
            ? [
                _c(
                  "el-collapse-item",
                  { attrs: { title: "柱体设置" } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "最大宽度" } },
                      [
                        _c("el-slider", {
                          attrs: { max: 200 },
                          model: {
                            value:
                              _vm.main.activeOption.extend.series.barMaxWidth,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.main.activeOption.extend.series,
                                "barMaxWidth",
                                $$v
                              )
                            },
                            expression:
                              "main.activeOption.extend.series.barMaxWidth",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "最小高度" } },
                      [
                        _c("el-slider", {
                          attrs: { max: 100 },
                          model: {
                            value:
                              _vm.main.activeOption.extend.series.barMinHeight,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.main.activeOption.extend.series,
                                "barMinHeight",
                                $$v
                              )
                            },
                            expression:
                              "main.activeOption.extend.series.barMinHeight",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.main.vaildProp("legendList")
            ? [
                _c(
                  "el-collapse-item",
                  { attrs: { title: "图例操作" } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "图例" } },
                      [
                        _c("el-switch", {
                          model: {
                            value: _vm.main.activeOption.legend.show,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.main.activeOption.legend,
                                "show",
                                $$v
                              )
                            },
                            expression: "main.activeOption.legend.show",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "位置" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { placeholder: "请选择" },
                            model: {
                              value: _vm.main.activeOption.legend.orient,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.main.activeOption.legend,
                                  "orient",
                                  $$v
                                )
                              },
                              expression: "main.activeOption.legend.orient",
                            },
                          },
                          _vm._l(_vm.dicOption.orientList, function (item) {
                            return _c("el-option", {
                              key: item.value,
                              attrs: { label: item.label, value: item.value },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "字体大小" } },
                      [
                        _c("el-input-number", {
                          model: {
                            value:
                              _vm.main.activeOption.legend.textStyle.fontSize,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.main.activeOption.legend.textStyle,
                                "fontSize",
                                $$v
                              )
                            },
                            expression:
                              "main.activeOption.legend.textStyle.fontSize",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "字体颜色" } },
                      [
                        _c("el-color-picker", {
                          model: {
                            value: _vm.main.activeOption.legend.textStyle.color,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.main.activeOption.legend.textStyle,
                                "color",
                                $$v
                              )
                            },
                            expression:
                              "main.activeOption.legend.textStyle.color",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.main.vaildProp("colorList")
            ? [
                _c(
                  "el-collapse-item",
                  { attrs: { title: "自定义配色" } },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: { click: _vm.addColor },
                      },
                      [_vm._v("添加")]
                    ),
                    _c(
                      "el-table",
                      {
                        staticStyle: { width: "100%" },
                        attrs: { data: _vm.dataColors },
                      },
                      [
                        _c("el-table-column", { attrs: { type: "index" } }),
                        _c("el-table-column", {
                          attrs: { prop: "color", label: "颜色" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("el-color-picker", {
                                      model: {
                                        value: scope.row.color,
                                        callback: function ($$v) {
                                          _vm.$set(scope.row, "color", $$v)
                                        },
                                        expression: "scope.row.color",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1118686548
                          ),
                        }),
                        _c("el-table-column", {
                          key: Math.random(),
                          attrs: {
                            fixed: "right",
                            label: "操作",
                            width: "120",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text", size: "small" },
                                        nativeOn: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.dataColors.splice(
                                              scope.$index,
                                              1
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(" 移除 ")]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1583827879
                          ),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }